import mitt from 'mitt';
const emitter = mitt();

export function useEmitter() {
    return {
        emitter
    };
}

export const Events = {
    initialized: 'initialized',
    dateChanged: 'dateChanged',
    updateServiceWorker: 'update-sw',
    serviceWorkerUpdated: 'sw-updated',
    online: 'online',
    notification: 'notification',
    menuUpdate: 'menu-update',
    goBack: 'go-back'
};
